function initProductCard(compareLabel, priceLabel, onSaleLabel) {
  document.querySelectorAll('product-card').forEach((cardEl) => {
    const mainImage = cardEl.querySelector('.product-card__image--primary');
    const secondaryImage = cardEl.querySelector('.product-card__image--secondary');
    const productLink = cardEl.querySelector('.product-card__media');
    const productDetails = cardEl.querySelector('.product-details');
    const variationCards = cardEl.querySelectorAll('.variation-card');
    const badgeContainer = cardEl.querySelector('badge-list');
    const priceContainer = cardEl.querySelector('.price-list');
    const badge = cardEl.querySelector('on-sale-badge');
    const lensLogo = cardEl.querySelector('.lens-logo img');
    const productTitle = cardEl.querySelector('.product-title');

    variationCards.forEach((variationCard) => {
      variationCard.addEventListener('click', () => {
        variationCards.forEach((vc) => vc.classList.remove('active'));
        variationCard.classList.add('active');

        const imageUrl = variationCard.dataset.image;
        const hoverImageUrl = variationCard.dataset.hoverImage;
        const productUrl = variationCard.dataset.url;
        const frameColor = variationCard.dataset.frameColor || '';
        const glassColor = variationCard.dataset.glassColor || '';
        const helmetColor = variationCard.dataset.helmetColor || '';
        const helmetLensColor = variationCard.dataset.helmetLensColor || '';
        const labelNew = variationCard.dataset.labelNew || '';
        const labelLimited = variationCard.dataset.labelLimited || '';
        const price = variationCard.dataset.price;
        const compare = variationCard.dataset.comparePrice;
        const labelOnSale = variationCard.dataset.labelOnSale;
        const lensLogoUrl = variationCard.dataset.lensLogo;
        const title = variationCard.dataset.title;

        if (mainImage) {
          mainImage.src = imageUrl;
          mainImage.srcset = imageUrl;
        }

        if (secondaryImage && hoverImageUrl) {
          secondaryImage.src = hoverImageUrl;
          secondaryImage.srcset = hoverImageUrl;
        }

        if (productLink) {
          productLink.href = productUrl;
        }

        if (lensLogo) {
          lensLogo.src = lensLogoUrl;
          lensLogo.srcset = lensLogoUrl;
        }

        productTitle.innerHTML = title;

        if (productDetails) {
          if (helmetColor || helmetLensColor) {
            let text = helmetColor || '';
            if (helmetLensColor) text += ' / ' + helmetLensColor;
            productDetails.innerHTML = text;
          } else {
            let text = frameColor || '';
            if (glassColor) text += ' / ' + glassColor;
            productDetails.innerHTML = text;
          }
        }

        if (badgeContainer) {
          let badges = '';

          if (labelNew === '1') {
            badges += `<span class="badge badge--custom badge--novita">${
              window.settings?.novita_badge_text || 'Novità'
            }</span>`;
          }

          if (labelLimited === '1') {
            badges += `<span class="badge badge--custom badge--edizione-limitata">${
              window.settings?.edizione_limitata_badge_text || 'Edizione Limitata'
            }</span>`;
          }

          if (labelOnSale === 'true') {
            badges += `<span class="badge badge--on-sale">${onSaleLabel}</span>`;
          }

          badgeContainer.innerHTML = badges;
        }

        if (priceContainer) {
          let html = '';
          const isOnSale =
            compare &&
            parseFloat(compare.replace(/[^\d,.-]/g, '').replace(',', '.')) >
              parseFloat(price.replace(/[^\d,.-]/g, '').replace(',', '.'));

          if (isOnSale) {
            html += `<sale-price class="heading text-on-sale"><span class="sr-only">${compareLabel}</span>${price}</sale-price>`;
            html += `<compare-at-price class="heading line-through"><span class="sr-only">${priceLabel}</span>${compare}</compare-at-price>`;
          } else {
            html += `<sale-price class="heading"><span class="sr-only">${priceLabel}</span>${price}</sale-price>`;
          }

          priceContainer.innerHTML = html;
        }
      });
    });
  });
}
